const Source = () => import('@/views/sourceView/index.vue')

export default {
  path: '/source',
  component: Source,
  children: [
    {
      name: 'navigation',
      path: 'navigation',
      meta: { needLogin: false },
      component: () => import('@/views/sourceView/navigation.vue')
    },
    {
      name: 'product',
      path: 'product',
      meta: { needLogin: false },
      component: () => import('@/views/sourceView/product.vue')
    },
    {
      name: 'product_list',
      path: 'productList',
      meta: { needLogin: false },
      component: () => import('@/views/sourceView/productList.vue')
    },
    {
      name: 'new_list',
      path: 'newList',
      meta: { needLogin: false },
      component: () => import('@/views/sourceView/newList.vue')
    },
    {
      name: 'case_list',
      path: 'caseList',
      meta: { needLogin: false },
      component: () => import('@/views/sourceView/caseList.vue')
    },
    {
      name: 'video',
      path: 'video',
      meta: { needLogin: false },
      component: () => import('@/views/sourceView/video.vue')
    },
    {
      name: 'certificate',
      path: 'certificate',
      meta: { needLogin: false },
      component: () => import('@/views/sourceView/certificate.vue')
    }
  ]
}
